// imove-behavior: 跳转登录页面

export default async function(ctx) {
  ctx.emit('routerPage', 'login');
}